/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PricingScheduleDto } from "./PricingScheduleDto";
import {
    PricingScheduleDtoFromJSON,
    PricingScheduleDtoFromJSONTyped,
    PricingScheduleDtoToJSON,
} from "./PricingScheduleDto";

/**
 *
 * @export
 * @interface ConnectorToPricingScheduleGroupDto
 */
export interface ConnectorToPricingScheduleGroupDto {
    /**
     *
     * @type {string}
     * @memberof ConnectorToPricingScheduleGroupDto
     */
    deviceIdentity?: string;
    /**
     *
     * @type {number}
     * @memberof ConnectorToPricingScheduleGroupDto
     */
    connectorIndex?: number;
    /**
     *
     * @type {PricingScheduleDto}
     * @memberof ConnectorToPricingScheduleGroupDto
     */
    pricingSchedule?: PricingScheduleDto;
}

/**
 * Check if a given object implements the ConnectorToPricingScheduleGroupDto interface.
 */
export function instanceOfConnectorToPricingScheduleGroupDto(
    value: object,
): value is ConnectorToPricingScheduleGroupDto {
    return true;
}

export function ConnectorToPricingScheduleGroupDtoFromJSON(
    json: any,
): ConnectorToPricingScheduleGroupDto {
    return ConnectorToPricingScheduleGroupDtoFromJSONTyped(json, false);
}

export function ConnectorToPricingScheduleGroupDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorToPricingScheduleGroupDto {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        connectorIndex:
            json["connectorIndex"] == null ? undefined : json["connectorIndex"],
        pricingSchedule:
            json["pricingSchedule"] == null
                ? undefined
                : PricingScheduleDtoFromJSON(json["pricingSchedule"]),
    };
}

export function ConnectorToPricingScheduleGroupDtoToJSON(
    value?: ConnectorToPricingScheduleGroupDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        connectorIndex: value["connectorIndex"],
        pricingSchedule: PricingScheduleDtoToJSON(value["pricingSchedule"]),
    };
}
